function AboutUs({ goBack }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#000000,#1a1a1a,#ffd600)",
        padding: "30px"
      }}
    >
      <button
        onClick={goBack}
        style={{
          backgroundColor: "#ffd600",
          border: "none",
          padding: "12px 20px",
          borderRadius: "10px",
          fontWeight: "bold",
          cursor: "pointer"
        }}
      >
        ⬅ Back
      </button>

      <div
        style={{
          maxWidth: "900px",
          margin: "30px auto",
          backgroundColor: "white",
          padding: "35px",
          borderRadius: "25px",
          boxShadow:
            "0 8px 25px rgba(0,0,0,0.3)"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "#000",
            marginBottom: "20px"
          }}
        >
          🏘️ About MNHouseFinder
        </h1>

        <p
          style={{
            lineHeight: "1.9",
            fontSize: "18px",
            marginBottom: "25px"
          }}
        >
          MNHouseFinder is a Kenyan
          digital property platform
          designed to connect tenants,
          landlords and commercial
          property owners in one place.

          Users can search for rental
          homes, apartments, office
          spaces and commercial
          buildings easily and safely.

          Property owners can also
          advertise their vacant
          properties and connect
          directly with clients.
        </p>

        <h2 style={{ color: "#d4a100", marginTop: "20px" }}>
          🎯 Our Vision
        </h2>

        <p style={{ marginBottom: "20px", lineHeight: "1.8" }}>
          To become Kenya's most
          trusted digital platform
          for finding residential
          and commercial spaces.
        </p>

        <h2 style={{ color: "#d4a100", marginTop: "25px" }}>
          🚀 Our Mission
        </h2>

        <p style={{ marginBottom: "20px", lineHeight: "1.8" }}>
          To simplify property
          searching by bringing
          tenants, landlords and
          commercial property
          owners together through
          one modern platform.
        </p>

        <h2 style={{ color: "#d4a100", marginTop: "25px" }}>
          ⭐ Our Core Values
        </h2>

        <p style={{ marginBottom: "6px" }}>✅ Integrity</p>
        <p style={{ marginBottom: "6px" }}>✅ Transparency</p>
        <p style={{ marginBottom: "6px" }}>✅ Innovation</p>
        <p style={{ marginBottom: "6px" }}>✅ Accessibility</p>
        <p style={{ marginBottom: "6px" }}>✅ Customer Satisfaction</p>
        <p style={{ marginBottom: "20px" }}>✅ Trust and Reliability</p>

        <h2 style={{ color: "#d4a100", marginTop: "25px" }}>
          🏢 What We Offer:
        </h2>

        <p style={{ marginBottom: "6px" }}>🏠 Residential houses</p>
        <p style={{ marginBottom: "6px" }}>🏬 Office spaces</p>
        <p style={{ marginBottom: "6px" }}>🏭 Commercial buildings</p>
        <p style={{ marginBottom: "0" }}>🏘️ Rental properties</p>
      </div>
    </div>
  );
}

export default AboutUs;